import { render, staticRenderFns } from "./ContentTile.vue?vue&type=template&id=47b0c193&scoped=true"
import script from "./ContentTile.vue?vue&type=script&lang=js"
export * from "./ContentTile.vue?vue&type=script&lang=js"
import style0 from "./ContentTile.vue?vue&type=style&index=0&id=47b0c193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0c193",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ContentTile.vue
// module id = 44
// module chunks = 0